import * as types from "../../constants";
import {
  //getInstrumentList as getInstrumentListService,
  updateInstrumentCalibration as updateInstrumentCalibrationService,
  insertInstrument as insertInstrumentService,
  updateInstrumentService as updateInstrumentAddressService,
  getInstrumentTypes as getInstrumentTypesService,
  getUncalibratedInstrument as getUncalibratedInstrumentService,
  getInstrumentListByCategory as getInstrumentListByCategoryService,
  updateService,
  getInstrumentDeployment as getInstrumentDeploymentService,
  getInstrumentDeploy as getInstrumentDeployService,
  updateTemperatureChartParametersService,
  getSpChkInstruments,
} from "../../services/InstDService";
import * as api from "../../services/APIService";
const route = "Hygeian/api/Instrument/";

export function getSpChkInstList(entid) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_SPCKINSTRUMENTD_PERNDING });

    return getSpChkInstruments(entid)
      .then((response) => {
        dispatch({
          type: types.FETCH_SPCKINSTRUMENTD_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_SPCKINSTRUMENTD_ERROR });
        throw error;
      });
  };
}

export function get() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INSTRUMENTD_PERNDING });

    return api
      .get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_INSTRUMENTD_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_INSTRUMENTD_ERROR });
        throw error;
      });
  };
}

export function getInstrumentList(categoryName, allInstrument = false) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INSTRUMENTD_PERNDING });
    return getInstrumentListByCategoryService(categoryName, allInstrument)
      .then((response) => {
        dispatch({
          type: types.FETCH_INSTRUMENTD_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_INSTRUMENTD_ERROR });
        throw error;
      });
  };
}

export function getInstrumentDeployment(categoryName) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_DEPLOYMENT_INSTRUMENTS_PENDING });
    return getInstrumentDeploymentService(categoryName)
      .then((response) => {
        dispatch({
          type: types.FETCH_DEPLOYMENT_INSTRUMENTS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_DEPLOYMENT_INSTRUMENTS_ERROR });
        throw error;
      });
  };
}

export function getInstrumentDeploy(InstrumentId) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_DEPLOYMENT_INSTRUMENTS_PENDING });
    return getInstrumentDeployService(InstrumentId)
      .then((response) => {
        dispatch({
          type: types.FETCH_DEPLOYMENT_INSTRUMENTS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_DEPLOYMENT_INSTRUMENTS_ERROR });
        throw error;
      });
  };
}

export function getInstrumentListByCategory(categoryName) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INSTRUMENT_BY_CATEGORY_PENDING });
    return getInstrumentListByCategoryService(categoryName)
      .then((response) => {
        dispatch({
          type: types.FETCH_INSTRUMENT_BY_CATEGORY_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_INSTRUMENT_BY_CATEGORY_ERROR });
        throw error;
      });
  };
}

export function getUncalibratedInstrument() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_UNCONFIGURED_INSTRUMENTS_PENDING });
    return getUncalibratedInstrumentService()
      .then((response) => {
        dispatch({
          type: types.FETCH_UNCONFIGURED_INSTRUMENTS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_UNCONFIGURED_INSTRUMENTS_ERROR });
        throw error;
      });
  };
}

export function getInstrumentTypes() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INSTRUMENT_TYPE_PENDING });
    return getInstrumentTypesService()
      .then((response) => {
        dispatch({
          type: types.FETCH_INSTRUMENT_TYPE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_INSTRUMENT_TYPE_ERROR });
        throw error;
      });
  };
}

export function updateInstrumentCalibration(event) {
  return async (dispatch) => {
    dispatch({ type: types.SET_INSTRUMENTD_UPDATE_PENDING });
    return updateInstrumentCalibrationService(event)
      .then((response) => {
        dispatch({
          type: types.SET_INSTRUMENTD_UPDATE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.SET_INSTRUMENTD_UPDATE_ERROR });
        throw error;
      });
  };
}

export function insertInstrument(event) {
  return async (dispatch) => {
    dispatch({ type: types.SET_INSTRUMENTD_INSERT_PENDING });
    return insertInstrumentService(event)
      .then((response) => {
        dispatch({
          type: types.SET_INSTRUMENTD_INSERT_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.SET_INSTRUMENTD_INSERT_ERROR });
        throw error;
      });
  };
}

export function updateInstrument(event) {
  return async (dispatch) => {
    dispatch({ type: types.SET_INSTRUMENTD_UPDATE_PENDING });
    return updateInstrumentAddressService(event)
      .then((response) => {
        dispatch({
          type: types.SET_INSTRUMENTD_UPDATE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.SET_INSTRUMENTD_UPDATE_ERROR });
        throw error;
      });
  };
}

export function update(event) {
  return async (dispatch) => {
    dispatch({ type: types.SET_INSTRUMENTD_UPDATES_PENDING });
    return updateService(event)
      .then((response) => {
        dispatch({
          type: types.SET_INSTRUMENTD_UPDATES_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.SET_INSTRUMENTD_UPDATES_ERROR });
        throw error;
      });
  };
}

export function updateTemperatureChartParameters(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_INSTRUMENT_BATTERY_PARAMETERS_PENDING });
    return (
      updateTemperatureChartParametersService(value)
        .then((response) => {
          dispatch({
            type: types.UPDATE_INSTRUMENT_BATTERY_PARAMETERS_SUCCESS,
            payload: response,
          });
        })
        // .then(() => {
        //   inst.getUncalibratedInstrument();
        // })
        .catch((error) => {
          dispatch({
            type: types.UPDATE_INSTRUMENT_BATTERY_PARAMETERS_ERROR,
            payload: error,
          });
          throw error;
        })
    );
  };
}
